import React from 'react';
import styled from 'styled-components';

import type { BaseWidgetSettingsControl } from 'src/context/constructorContext/types';

interface ITextControl {
  controlName: string;
  controlValue: BaseWidgetSettingsControl<string | number>;
  applySettings: (
    controlName: string,
    controlValue: BaseWidgetSettingsControl<string | number>,
    newValues: Partial<BaseWidgetSettingsControl<string | number>>
  ) => void;
}

export const TextControl = (props: ITextControl): JSX.Element => {
  const { controlName, controlValue, applySettings } = props;

  return (
    <Input
      type="text"
      value={controlValue.value}
      onChange={(e) => {
        applySettings(controlName, controlValue, {
          value: ['adults', 'kids'].includes(controlName)
            ? Number(e.target.value) || 0
            : e.target.value,
        });
      }}
    />
  );
};

const Input = styled.input`
  width: 100%;
  height: 38px;
  background-color: hsl(0, 0%, 100%);
  border-color: hsl(0, 0%, 80%);
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  padding: 2px 8px;

  &:focus {
    border-color: #007aff;
    border-width: 2px;
  }
`;
